// Compatibility shim (Wave 1 · P4-B, ARCFE-666). This endpoint-hub CLIENT
// module was misparked in pages/api (it was never a route — no default
// handler) and now lives at @/api/scribeAPIV2. Named runtime re-exports keep existing
// importers and jest.mock('@/pages/api/…') literals working unchanged;
// burned down per-domain as data/api slices carve out (Waves 2–3, tasks Z2).
// (Named, not `export *`: Next.js forbids export-all in pages/api modules — export-all-in-page.)
export {
  BulkUploadSnippetErrorType,
  IntegrationAgentOnlineStatus,
  InviteUsersToTeams,
  acceptTeamInvitation,
  activateClinicianTrial,
  activatePracticeTrial,
  activatePromotedFreeTrial,
  addBlockedNumber,
  addCustomAgentScenario,
  addNewClinicalCode,
  addToGroup,
  analyzeSessionNote,
  applySubscriptionDiscount,
  askAI,
  assignClinicalTask,
  assignTeamEntitlementAsTeamAdmin,
  assignUserEntitlementAsTeamAdmin,
  buildDocumentContentPath,
  buildDocumentContentRequestPath,
  bulkAssignUserEntitlementsAsTeamAdmin,
  bulkCreateCall,
  bulkDeleteChats,
  bulkDeleteClinicalTasks,
  bulkDeleteUserEntitlementsAsTeamAdmin,
  bulkUpdateClinicalTasks,
  cancelReverseTrial,
  changePlan,
  checkGuardrail,
  checkMindbodySiteAccess,
  clearOrganizationSessionTimeout,
  clearUserSessionTimeout,
  commitAgentFromObjective,
  confirmClinicalCode,
  confirmEmLevelDeterminator,
  confirmMergedSessions,
  confirmSessionProblems,
  connectIntegration,
  connectIntegrationEhrLaunch,
  continueChat,
  createAddOnProductCheckoutSession,
  createAgentBuilderSession,
  createCall,
  createCallsEHRCredentials,
  createChat,
  createChatSuggestions,
  createCheckoutSession,
  createClinicalTask,
  createIntegrationContactSalesRequest,
  createIntegrationOnboardingSession,
  createIntegrationWorkflowSession,
  createLatestVersionControl,
  createLetterFromDocument,
  createMKTemplateRequest,
  createPDFDocument,
  createPatientProfile,
  createPrescription,
  createProtocol,
  createPublicTemplateSuggestions,
  createReminderConfig,
  createSessionLinkShare,
  createSharedTemplate,
  createTeam,
  createTeamInvitationLink,
  createTeamInvitationLinkWithRoleIds,
  createTemplate,
  createTemplateCreationRecord,
  createTemplateCreationRecordByTemplateId,
  createTemplateSuggestions,
  createTextChatSession,
  createUser,
  createUserInmail,
  createUserSnippet,
  createUserSnippetsBatch,
  deactivatePromotedFreeTrial,
  deleteAllNotifications,
  deleteAllReadNotifications,
  deleteAllSessions,
  deleteBlockedNumber,
  deleteCall,
  deleteCallAgent,
  deleteCallsPatient,
  deleteCallsUserEHRCredentials,
  deleteChatAttachment,
  deleteClinicalTask,
  deleteContextDocuments,
  deleteEmptySessions,
  deleteIntegration,
  deleteIntegrationEhrLaunch,
  deleteIntegrationOnboardingSession,
  deleteLetter,
  deleteLetterAttachmentV2,
  deleteMemberPatientProfile,
  deleteNotification,
  deleteOrganizationTeamMember,
  deletePatientDocument,
  deletePatientProfile,
  deletePatientProfiles,
  deletePersonalizationInsight,
  deletePrescription,
  deleteProtocol,
  deleteProtocolDocument,
  deleteReminderConfig,
  deleteSharepointConfig,
  deleteTeam,
  deleteTeamEntitlementAsTeamAdmin,
  deleteTeamMember,
  deleteTemplateV2,
  deleteTemplateVersionControl,
  deleteUnLinkSessionsToPatientProfile,
  deleteUserEntitlementAsTeamAdmin,
  deleteUserSnippet,
  discardMergedSessions,
  dismissPostNoteQualityPanel,
  editTemplate,
  editTemplateFavoriteStatus,
  editTemplatePinStatus,
  editTemplatePublic,
  enablePrechartForUser,
  extendReverseTrial,
  fillFormDemo,
  fillFormDemoFromUpload,
  fillXmlFormDemo,
  fillXmlFormDemoFromUpload,
  generateBackupTranscript,
  generateDocument,
  generateEhrLaunchToken,
  generateExampleNotePublic,
  generateKnowledgeBase,
  generatePrechartDocument,
  generateProtocol,
  generateReferralLink,
  generateSessionClinicalTasks,
  generateTemplateContentUsingAICommand,
  generateTemplatePublic,
  getAICommandsBySessionId,
  getAdaptiveLearningAvailability,
  getAddOnProducts,
  getAgentGreeting,
  getAgentPredictedParameters,
  getAgentQARun,
  getAvailableConnectors,
  getAvailableDirectIntegrations,
  getAvailableEhrSections,
  getBackupAudio,
  getBlockedNumbers,
  getCall,
  getCallAgent,
  getCallAgentWebRTCToken,
  getCallAgents,
  getCallTranslation,
  getCallVoiceCatalog,
  getCalls,
  getCallsChatApiBaseUrl,
  getCallsEHRAppointmentTypes,
  getCallsEHRClinicians,
  getCallsEHRClinics,
  getCallsPatientAppointments,
  getCallsPatients,
  getCallsUserEHRCredentials,
  getCapabilities,
  getCapabilityAutocomplete,
  getCernerNoteTypes,
  getClinicalTaskById,
  getClinicalTasks,
  getClinikoPractitionerInfo,
  getConsultNoteTemplates,
  getConsultNoteTemplatesById,
  getConsultNotes,
  getContextDocumentFile,
  getContextDocuments,
  getConversationDetail,
  getConversations,
  getDictationCleanupModes,
  getDocumentAICommandsBySessionId,
  getDocumentTemplates,
  getDocx,
  getEHRAppointments,
  getEHRUsers,
  getEHRUsersByClinicId,
  getEHRUsersV2,
  getEhrAuthUrl,
  getEhrLaunchCommonlyUsedPastEhrNotes,
  getEhrLaunchPastNoteDetails,
  getEhrLaunchPastNotes,
  getEhrLaunchPatient,
  getEhrLetterTemplates,
  getEntitlements,
  getEntityFeedback,
  getEvidenceIntegrations,
  getExportAssetDownloadUrl,
  getExportAssetUploadUrl,
  getFeatureFlags,
  getFeedbackV2,
  getFilledDocxTemplate,
  getFilledPDFTemplate,
  getFilledPdfFields,
  getFollowUpQuestions,
  getGamifyTrialExtension,
  getGuardrailsV2RequestConfig,
  getHaikuAvailableSections,
  getHaikuLatestRecordingId,
  getHaikuLaunchInfo,
  getInboxCallDetail,
  getInitialPinnedTemplates,
  getIntegrationAgentStatus,
  getIntegrationAvailableStandardizedSections,
  getIntegrationCapabilities,
  getIntegrationContactSalesRequest,
  getIntegrationLinkedConsultNoteInfo,
  getIntegrationLinkedSessionInfo,
  getIntegrationOnboardingSessionById,
  getIntegrationOnboardingSessions,
  getIntegrationsSchedule,
  getInternalTemplateById,
  getJoinableTeams,
  getJoinedOrganization,
  getJoinedTeams,
  getJurisdictionsByCountry,
  getLastAgentSimulationRun,
  getLetterAttachmentDownloadUrlV2,
  getLetterAttachmentsV2,
  getLetterHead,
  getLetterTimelineEvents,
  getLetters,
  getLiveTranscript,
  getLogoutEligibleCount,
  getMKTemplateRequestById,
  getMemberPatientProfile,
  getMergeableSessions,
  getMyMKTemplateRequests,
  getNoteOptionsForIntegration,
  getNotificationPreferences,
  getOperationalBreakdowns,
  getOperationalDaily,
  getOperationalSummary,
  getOrgAnalyticsDashboard,
  getOrganizationByOrganizationId,
  getOrganizationLogoutJob,
  getOrganizationMembers,
  getOrganizationTeams,
  getOrganizationTemplates,
  getOrganizationTemplatesMetadata,
  getOverallFeedback,
  getPatientContext,
  getPatientDocumentWithDownloadUrl,
  getPatientDocuments,
  getPatientProfiles,
  getPatientRecap,
  getPatientSummaryEmailPreview,
  getPatientSummaryPreviewPdf,
  getPdf,
  getPinnedTemplates,
  getPrechartInstructions,
  getPrechartStats,
  getPrechartingEnabled,
  getPrescription,
  getProducts,
  getProtocolById,
  getProtocolByShorthand,
  getProtocols,
  getRecommendedTemplates,
  getReminderConfigs,
  getRepeatReviews,
  getResolvedSettings,
  getRoles,
  getSessionAnalysis,
  getSessionClinicalCodes,
  getSessionConsultNoteTimeline,
  getSessionCountBySessionStatus,
  getSessionLinkShares,
  getSessionPatientDocumentLinks,
  getSessionProblems,
  getSessionTranscript,
  getSessions,
  getSessionsByEhrPatientId,
  getSessionsByPatientProfileId,
  getSessionsByTeamMemberId,
  getSessionsWithPagination,
  getSessionsWithQueryParams,
  getSharedChat,
  getSharedChatFromRegion,
  getSharedTemplate,
  getSharepointConfig,
  getSharepointOauthStartRedirectUrl,
  getSharepointSiteContents,
  getSharepointSiteFolderContents,
  getSharepointSites,
  getSyncDocumentOptions,
  getTeamAccessEntitlements,
  getTeamAnalyticsDashboard,
  getTeamBillingDetails,
  getTeamDetails,
  getTeamMemberAccessEntitlements,
  getTeamMemberSessionById,
  getTeamMemberSessionCountBySessionStatus,
  getTeamMemberSessionsByPatientProfileId,
  getTeamMembersWithRelationship,
  getTeamSessionsForAssistantView,
  getTemplateById,
  getTemplateCreationRecordById,
  getTemplateCreationRecordByTemplateId,
  getTemplateSectionMapping,
  getTemplates,
  getTextChatStreamUrl,
  getTriageReview,
  getTriageReviews,
  getUploadTemplateURL,
  getUserAddOnBillingInfo,
  getUserBillingInfo,
  getUserCapabilities,
  getUserEHR,
  getUserEHRLaunchProfile,
  getUserEHRLaunchProfileAuth0,
  getUserInmails,
  getUserPersonalizations,
  getUserSnippets,
  getV2StreamHeaders,
  graduateNoteSuggestion,
  importPatientProfiles,
  linkMergedSessions,
  linkPatientDocumentsToSession,
  linkSessionsToPatientProfile,
  listAgentScenarios,
  logApiStatusCheck,
  logClientSdkDiagnostics,
  logFrontendDiagnostics,
  logoutAllMatchingOrganizationMembers,
  logoutOrganizationMembersEverywhere,
  markConversationRead,
  markModalAsViewed,
  markPostNoteQualityPanelSeen,
  markPostNoteQualityTaskCompleted,
  mergePatientProfiles,
  mintCodingCaseAccessContext,
  moveOrganizationMemberTeam,
  pairBPSite,
  patchCall,
  patchIntegrationSessionLink,
  patchMemberPatientProfile,
  patchSettings,
  postBulkCreateSessions,
  postBulkCreateSessionsForTeamMember,
  postCreateEmptyDocument,
  postCreateSessionForOtherUser,
  postCreateSessionV2,
  postEvidenceUpgradeCheckout,
  postInboxWebSocketTicket,
  postLinkSessionsToPatientProfile,
  postMemberPatientProfile,
  postOutgoingLetter,
  postPushNoteToHaiku,
  postUploadSessionSchedule,
  preparePatientSummaryDelivery,
  previewCallVoice,
  processReminders,
  processUploadedDocument,
  processUploadedDocumentPublic,
  purchaseCallAgentPhoneNumber,
  pushCodesToEHR,
  queuePrechartsForUser,
  readAllNotifications,
  readNotification,
  recompileAgent,
  recordGamifySourceControlUsed,
  recordGamifyTemplateSelected,
  recordNoteSuggestionFeedback,
  refreshAgentScenarios,
  refreshCallsEHRAppointmentTypes,
  refreshCallsEHRClinicians,
  refreshCallsEHRClinics,
  regenerateAgentScenarios,
  rejectClinicalCode,
  removeEmLevelDeterminator,
  removeHealthPathwaysZone,
  replaceTemplateSectionMapping,
  requestEHRIntegration,
  resendTeamInvitation,
  resetClinicalCodesQuota,
  resyncSharepointConfig,
  retryAppointmentReminder,
  revertMergedSessions,
  revertReverseTrial,
  revertSessionConsultNote,
  revokeSessionLinkShareRecipient,
  runAgentQA,
  saveSharedChatCopy,
  searchClinicalCodes,
  searchClinics,
  searchLetterRecipients,
  searchOrganizationMembers,
  searchPatientProfiles,
  sendAgentBuilderChat,
  sendGetMobileEmail,
  sendInboxMessage,
  sendLetter,
  sendPatientSummaryDelivery,
  sendPatientSummaryEmailDelivery,
  setInitialPinnedTemplates,
  setOrganizationSessionTimeout,
  setUserSessionTimeout,
  setupHealthPathwaysZone,
  shareChat,
  shareDocumentByEmail,
  shareTemplateByEmail,
  signLetter,
  simulateAgentStream,
  startAutoVerification,
  storeChatsFromLocalStorage,
  submitChatFeedback,
  submitClinicalCodeFeedback,
  submitConsultNoteFeedback,
  submitDocumentFeedback,
  submitEntityFeedback,
  submitEvidenceFeedback,
  submitFeedbackV2,
  submitOverallFeedback,
  submitPrechartFeedback,
  submitSafetyIssueTicket,
  syncDocuments,
  syncNoteAudit,
  syncNoteToIntegration,
  syncNoteWithOptionsToIntegration,
  syncNotesToEHR,
  syncNotesToEHRWithEHRLaunch,
  syncSDEsToEHR,
  syncSectionalNoteToIntegration,
  syncSectionsNoteToEHR,
  togglePersonalizationInsight,
  togglePrechartingEnabled,
  toggleReminderConfig,
  toggleTeamConsent,
  toggleTeamMfa,
  toggleTeamPatientRetention,
  toggleTeamReviewConfirmation,
  toggleTeamSessionRetention,
  toggleTeamSessionReviewWithRoleIds,
  toggleUserMfa,
  unassignClinicalTask,
  unconfirmClinicalCode,
  unlinkMergedSessions,
  unlinkPatientDocumentFromSession,
  unlinkSessionsToPatientProfile,
  unreadNotification,
  updateAutoExtractIntent,
  updateAutoLinkIntent,
  updateCallAgent,
  updateCallsEHRAppointmentType,
  updateCallsEHRClinic,
  updateCallsEHRClinician,
  updateCapabilityActions,
  updateClinicalTask,
  updateConsultNote,
  updateContextDocuments,
  updateConversation,
  updateDocuments,
  updateIntegrationEhrLaunch,
  updateIntegrationOnboardingSessionStep,
  updateJSONConsultNoteSectionLink,
  updateLetter,
  updateOrganizationById,
  updateOrganizationMemberRole,
  updatePatientProfile,
  updatePdfFields,
  updatePinnedTemplateOrder,
  updatePrechartInstructions,
  updatePrescription,
  updateProtocol,
  updateReminderConfig,
  updateRepeatReviewStatus,
  updateSessionForOtherUser,
  updateSharepointConfig,
  updateSubscriptionWithAddOnProduct,
  updateTeam,
  updateTeamSettings,
  updateTemplateCreationRecord,
  updateTemplateVersionControl,
  updateUserRole,
  updateUserSnippet,
  uploadBackupAudio,
  uploadCallsPatientsCsv,
  uploadChatAttachment,
  uploadContextDocument,
  uploadFileToIntegration,
  uploadInboxMedia,
  uploadLetterAttachmentV2,
  uploadPatientDocument,
  uploadProtocolDocument,
  uploadSnippetsBatchCsv,
  userSelfOnboard,
  validatePairingCode,
} from '@/api/scribeAPIV2';
export type {
  AdaptiveLearningAvailabilityResponse,
  AgentBuilderChatResponse,
  AgentScenario,
  AgentSimulationRun,
  ApiStatusCheckResultPayload,
  BlockedNumber,
  BlockedNumberListResponse,
  BlockedVia,
  BulkClinicalTasksResponse,
  BulkDeleteChatsResponse,
  CapabilityListResponse,
  CapabilityWithUserConfigListResponse,
  ChatAttachmentResponse,
  ChatFeedbackRequest,
  ChatFeedbackResponse,
  ContinueChatResponse,
  CreateBlockedNumberPayload,
  CreateBlockedNumberResponse,
  CreateSnippetsRequest,
  FollowUpQuestionsRequest,
  FollowUpQuestionsResponse,
  GeneratePrechartDocumentResponse,
  GetRepeatReviewsResponse,
  GetTriageReviewsResponse,
  GraduateNoteSuggestionResponse,
  InboxWebSocketTicketResponse,
  IntegrationAgentStatusResponse,
  JurisdictionOptionResponse,
  LinkMergedSessionsRequest,
  LinkMergedSessionsResponse,
  LogApiStatusCheckRequest,
  LogApiStatusCheckResponse,
  PatchCallPayload,
  PrechartAdminEnableRequest,
  PrechartAdminEnableResponse,
  PrechartFeedbackRating,
  PrechartFeedbackRequest,
  PrechartInstructionsResponse,
  PrechartQueueResponse,
  PrechartStatsBucket,
  PrechartStatsResponse,
  PrechartingToggleResponse,
  PreviewConversationTurn,
  Protocol,
  ProtocolListResponse,
  RecordNoteSuggestionFeedbackRequest,
  RecordNoteSuggestionFeedbackResponse,
  ResolvedSettingView,
  SettingsCollectionResponse,
  ShareChatResponse,
  ShareDocumentByEmailRecipientsRequest,
  SharePointOAuthStartResponse,
  ShareTemplateByEmailRequest,
  ShareTemplateByEmailResponse,
  ShareTemplateByEmailResult,
  SharedChatCopyRequest,
  SharedChatMessage,
  SharedChatResponse,
  SharepointSiteContentItem,
  SharepointSiteContentsResponse,
  SharepointSiteInfo,
  SharepointSitesResponse,
  SharepointSyncConfigResponse,
  SharepointSyncConfigUpdateRequest,
  SharepointSyncFolderConfig,
  SharepointSyncFolderSelection,
  SharepointSyncSiteConfig,
  SharepointSyncSiteSelection,
  SingleSnippetResponse,
  Snippet,
  SnippetsResponse,
  SnippetsUploadResponse,
  TeamSessionItem,
  TeamSessionsParams,
  TeamSessionsResponse,
  UnlinkMergedSessionsRequest,
  UnlinkMergedSessionsResponse,
  UpdateSingleSnippetRequest,
  UploadRow,
  UserCapabilityConfig,
  VerbalTriggerIntent,
} from '@/api/scribeAPIV2';
